import { Component } from '@angular/core';
import { IzzyTicketSLAStateEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Ticket SLA States') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyticketslastate-form',
    templateUrl: './izzyticketslastate.form.component.html'
})
export class IzzyTicketSLAStateFormComponent extends BaseFormComponent {
    public record!: IzzyTicketSLAStateEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'ticketAssociation', sectionName: 'Ticket Association', isExpanded: true },
            { sectionKey: 'sLATimeline', sectionName: 'SLA Timeline', isExpanded: true },
            { sectionKey: 'sLAClockManagement', sectionName: 'SLA Clock Management', isExpanded: true },
            { sectionKey: 'sLABreachTracking', sectionName: 'SLA Breach Tracking', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

